<div class="mat-dialog-ui">
    <label (click)="action(false)" mat-button mat-dialog-close class="mat-close-btn cursor-pointer btn-close-icon">
        <span class="material-icons cursor-pointer" (click)="action(false)">
            close
        </span>
    </label>
    <div class="account-slider">
        <div class="account-slider-wrapper">
            <div class="item">
                <p class="dialog-title">{{title}}</p>
                <p class="dialog-message" [innerHTML]="message">
                </p>
                <div class="row justify-content-center align-items-center">
                    <div class="col-md-auto">
                        <button type="button mr-3" style="margin-right: 10px !important;" *ngIf="showCancel"
                            class="btn btn-light-orange" (click)="action(false)">{{ cancelButtonText }}</button>
                        <button type="button" class="btn btn-light-orange" (click)="action(true)">{{ okButtonText
                            }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>